import { useQuery } from '@tanstack/react-query';
import { API_CONFIG } from '@/lib/api';

export function useMessageAnalytics(businessAccountId?: string, dateRange?: { start: string; end: string }) {
  return useQuery({
    queryKey: ['message-analytics', businessAccountId, dateRange],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (businessAccountId) params.append('businessAccountId', businessAccountId);
      if (dateRange?.start) params.append('startDate', dateRange.start);
      if (dateRange?.end) params.append('endDate', dateRange.end);

      const token = localStorage.getItem('auth_token');
      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_CONFIG.BASE_URL}/analytics/messages?${params.toString()}`, {
        headers,
      });
      if (!response.ok) throw new Error('Failed to fetch message analytics');
      
      const result = await response.json();
      return result.data;
    },
    enabled: !!businessAccountId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}

export function useConversationAnalytics(businessAccountId?: string, dateRange?: { start: string; end: string }) {
  return useQuery({
    queryKey: ['conversation-analytics', businessAccountId, dateRange],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (businessAccountId) params.append('businessAccountId', businessAccountId);
      if (dateRange?.start) params.append('startDate', dateRange.start);
      if (dateRange?.end) params.append('endDate', dateRange.end);

      const token = localStorage.getItem('auth_token');
      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_CONFIG.BASE_URL}/analytics/conversations?${params.toString()}`, {
        headers,
      });
      if (!response.ok) throw new Error('Failed to fetch conversation analytics');

      const result = await response.json();
      return result.data;
    },
    enabled: !!businessAccountId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}

export function useCampaignAnalytics(businessAccountId?: string, dateRange?: { start: string; end: string }) {
  return useQuery({
    queryKey: ['campaign-analytics', businessAccountId, dateRange],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (businessAccountId) params.append('businessAccountId', businessAccountId);
      if (dateRange?.start) params.append('startDate', dateRange.start);
      if (dateRange?.end) params.append('endDate', dateRange.end);

      const token = localStorage.getItem('auth_token');
      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_CONFIG.BASE_URL}/analytics/campaigns?${params.toString()}`, {
        headers,
      });
      if (!response.ok) throw new Error('Failed to fetch campaign analytics');

      const result = await response.json();
      return result.data;
    },
    enabled: !!businessAccountId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}

export function useAgentPerformance(businessAccountId?: string, dateRange?: { start: string; end: string }) {
  return useQuery({
    queryKey: ['agent-performance', businessAccountId, dateRange],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (businessAccountId) params.append('businessAccountId', businessAccountId);
      if (dateRange?.start) params.append('startDate', dateRange.start);
      if (dateRange?.end) params.append('endDate', dateRange.end);

      const token = localStorage.getItem('auth_token');
      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_CONFIG.BASE_URL}/analytics/agents?${params.toString()}`, {
        headers,
      });
      if (!response.ok) throw new Error('Failed to fetch agent analytics');

      const result = await response.json();
      return result.data;
    },
    enabled: !!businessAccountId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}

export function useOverviewAnalytics(businessAccountId?: string, dateRange?: { start: string; end: string }) {
  return useQuery({
    queryKey: ['overview-analytics', businessAccountId, dateRange],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (businessAccountId) params.append('businessAccountId', businessAccountId);
      if (dateRange?.start) params.append('startDate', dateRange.start);
      if (dateRange?.end) params.append('endDate', dateRange.end);

      const token = localStorage.getItem('auth_token');
      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_CONFIG.BASE_URL}/analytics/overview?${params.toString()}`, {
        headers,
      });
      if (!response.ok) throw new Error('Failed to fetch overview analytics');
      
      const result = await response.json();
      return result.data;
    },
    enabled: !!businessAccountId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
